import { render, staticRenderFns } from "./RoomProviders.vue?vue&type=template&id=454b7601&scoped=true&"
import script from "./RoomProviders.vue?vue&type=script&setup=true&lang=ts&"
export * from "./RoomProviders.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./RoomProviders.vue?vue&type=style&index=0&id=454b7601&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "454b7601",
  null
  
)

export default component.exports